module.exports = __webpack_public_path__ + "img/ic_local_airport_black_48px.8796a322.svg";